const formatOptions = {
    units: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        signDisplay: 'negative',
    },
    // One decimal below 10, none from 10, decided after rounding
    thousands: {
        maximumFractionDigits: 0,
        maximumSignificantDigits: 2,
        roundingPriority: 'morePrecision',
        signDisplay: 'negative',
    },
};
const minorUnitsPer = {
    units: 100,
    thousands: 100_000,
};
const formats = new Map();
const numberFormat = (locale, scale) => {
    const key = `${locale}|${scale}`;
    if (!formats.has(key)) {
        formats.set(key, new Intl.NumberFormat(locale, formatOptions[scale]));
    }
    return formats.get(key);
};
// Amounts are in minor units (øre)
export const formatMoney = (locale, amount, scale = 'units') => numberFormat(locale, scale).format(amount / minorUnitsPer[scale]);
//# sourceMappingURL=format-money.js.map